import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  return <section className="py-16 bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white" data-id="element-362">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-363">
        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-364">
          Ready to Start Your Journey?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-365">
          Try us risk-free for two weeks. Experience our classes, meet our
          instructors, and discover why families across Mid-Michigan choose Che
          Ko Martial Arts.
        </p>
        <Link to="/contact" data-id="element-366">
          <Button variant="secondary" size="lg" className="text-lg shadow-xl" data-id="element-367">
            Get 2 Weeks Free
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-368" />
          </Button>
        </Link>
      </div>
    </section>;
}